import { T } from '@tolgee/react';
import React from 'react';
import styled from 'styled-components';

import theme from '../../../assets/theme';
import { zIndexes } from '../../../utils/zIndexes';

interface AIFeedbackOverlayProps {
  visible: boolean;
  onComplete?: () => void;
}

const AIFeedbackOverlay: React.FC<AIFeedbackOverlayProps> = ({ visible }) => {
  if (!visible) return null;

  return (
    <OverlayContainer>
      <BlurBackground />
      <ContentContainer>
        <MessageText>
          <T
            keyName="Read the feedback on your device"
            defaultValue="Read the feedback on your device"
          />
        </MessageText>
      </ContentContainer>
    </OverlayContainer>
  );
};

const OverlayContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: ${zIndexes('AI_FEEDBACK_OVERLAY')};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BlurBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${theme.colors.translucentBlack};
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
`;

const ContentContainer = styled.div`
  position: relative;
  z-index: ${zIndexes('AI_FEEDBACK_OVERLAY') + 1};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
`;

const MessageText = styled.div`
  font-size: 80px;
  font-weight: bold;
  color: ${theme.colors.white};
  text-align: center;
  max-width: 90%;
  line-height: 1.2;
`;

export default AIFeedbackOverlay;
